import { useReveal, useFocalPoint, SpringParallax } from '@ccg/core';
import React$1 from 'react';
import PropTypes$1 from 'prop-types';
import Caption$1 from '../Caption/Caption.js';
import Framer$1 from '../Framer/Framer.js';
import RevealBox$1 from '../RevealBox/RevealBox.js';
import StyledMediaContent from './MediaContent.style.js';

/* eslint-disable react/jsx-one-expression-per-line, react/no-array-index-key */

const MediaContent = ({
  className,
  hasFocalPoint,
  focalPoint,
  variant,
  caption,
  framerCaption,
  credits,
  children,
  shadow,
  noReveal
}) => {
  const [ref, isVisible] = useReveal();
  const {
    isRightAligned
  } = useFocalPoint(hasFocalPoint, focalPoint, false);

  const getFramerCaptionAlignment = () => {
    if (variant === 'l' || variant === 'xl') return isRightAligned ? 'left' : 'right';
    return isRightAligned ? 'right' : 'left';
  };

  const getCaptionRotation = () => {
    return isRightAligned ? 'left' : 'right';
  };

  return /*#__PURE__*/React$1.createElement(StyledMediaContent, {
    className: className,
    variant: variant,
    isRightAligned: isRightAligned,
    hasFocalPoint: hasFocalPoint,
    shadow: shadow,
    ref: ref
  }, /*#__PURE__*/React$1.createElement(SpringParallax, {
    className: "mediaContent__framer-wrapper"
  }, /*#__PURE__*/React$1.createElement(Framer$1, {
    isVisible: isVisible,
    alignment: getFramerCaptionAlignment(),
    hasIndex: true,
    inverse: variant === 'l',
    caption: framerCaption
  })), /*#__PURE__*/React$1.createElement(SpringParallax, {
    className: "mediaContent__media-wrapper"
  }, noReveal ? children : /*#__PURE__*/React$1.createElement(RevealBox$1, {
    isVisible: isVisible
  }, children)), (caption || credits) && /*#__PURE__*/React$1.createElement(Caption$1, {
    className: "mediaContent__meta",
    rotateTo: getCaptionRotation(),
    caption: caption,
    isVisible: isVisible,
    credits: credits
  }));
};

MediaContent.propTypes = {
  className: PropTypes$1.string,
  hasFocalPoint: PropTypes$1.bool,
  focalPoint: PropTypes$1.arrayOf(PropTypes$1.number),
  credits: PropTypes$1.string,
  variant: PropTypes$1.oneOf(['s', 'm', 'l', 'xl']),
  caption: PropTypes$1.string,
  framerCaption: PropTypes$1.string,
  children: PropTypes$1.node,
  noReveal: PropTypes$1.bool,
  shadow: PropTypes$1.bool
};
MediaContent.defaultProps = {
  className: '',
  hasFocalPoint: false,
  focalPoint: [0.5, 0.5],
  credits: null,
  variant: 'm',
  caption: null,
  framerCaption: null,
  children: null,
  noReveal: false,
  shadow: false
};

export default MediaContent;
